import { useEffect } from "react";

export const WithoutMenu = () => {
  ////////
  // Hooks
  ////////
  useEffect(() => {
    // Update title
    document.title = "COFLPA - Sin menú";
  }, []);

  return (
    <div className="ycs-card" style={{ boxSizing: "border-box", textAlign: "center", padding: "10px 0", marginTop: 5 }}>
      De momento no tiene un menú asignado
    </div>
  );
}